export { default } from "./SearchResultsSubjectIcon";
